/**
 * For now this is copy/pasted from the back end code. Would be nice to libraryize it
 *
 */
// Boolean user auths: user can do x
export const AUTHORIZATIONS = {
    // probably need to remove CAN_ACCESS_ROOT_VIEWS now and make more granular
    CAN_ACCESS_ROOT_VIEWS: 'CAN_ACCESS_ROOT_VIEWS',
    CAN_EDIT_SITES: 'CAN_EDIT_SITES',
    CAN_EDIT_ROOT_SITES: 'CAN_EDIT_ROOT_SITES',
    CAN_EDIT_USERS: 'CAN_EDIT_USERS',
    CAN_EDIT_FILTERS: 'CAN_EDIT_FILTERS',
    CAN_EDIT_ADMIN_USERS: 'CAN_EDIT_ADMIN_USERS',
    CAN_EDIT_SUPERUSERS: 'CAN_EDIT_SUPERUSERS',
    CAN_ACT_AS: 'CAN_ACT_AS',
    CAN_LOGIN: 'CAN_LOGIN',
    CAN_CHANGE_USER_PASSWORD: 'CAN_CHANGE_USER_PASSWORD',
    CAN_EDIT_USER_TOKENS: 'CAN_EDIT_USER_TOKENS',
    CAN_VERIFY_USER_DEVICES: 'CAN_VERIFY_USER_DEVICES',
    CAN_SEE_USER_DEVICES: 'CAN_SEE_USER_DEVICES',
    CAN_SEE_USER_IDS: 'CAN_SEE_USER_IDS',
    CAN_MANAGE_VIDEO_SERVICE: 'CAN_MANAGE_VIDEO_SERVICE',
    CAN_MANAGE_MASTER_TOKENS: 'CAN_MANAGE_MASTER_TOKENS',
    CAN_SEE_USER_HISTORY: 'CAN_SEE_USER_HISTORY',
    CAN_SEE_SITE_HISTORY: 'CAN_SEE_SITE_HISTORY',
};
